(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-ritual-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-arv-player]').forEach(function(player) {
      var video = player.querySelector('.article-ritual-video__video');
      var btn = player.querySelector('[data-arv-play]');

      function requestFullscreen() {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        }
      }

      function startPlay() {
        requestFullscreen();
        video.play();
        btn.classList.add('is-hidden');
      }

      btn.addEventListener('touchstart', function(e) {
        e.preventDefault();
        startPlay();
      }, { passive: false });

      btn.addEventListener('click', startPlay);

      video.addEventListener('click', function() {
        if (video.paused) {
          startPlay();
        } else {
          video.pause();
          btn.classList.remove('is-hidden');
        }
      });

      video.addEventListener('ended', function() {
        btn.classList.remove('is-hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.card-grid__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var card = this.closest('.card-grid__card');
      var text = card.querySelector('.card-grid__text');
      var footer = card.querySelector('.card-grid__footer');
      this.setAttribute('aria-expanded', String(!expanded));
      if (text) {
        text.setAttribute('aria-hidden', String(expanded));
        text.classList.toggle('is-open', !expanded);
      }
      if (footer) {
        footer.classList.toggle('is-open', !expanded);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {

    document.querySelectorAll('[data-discount-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).then(function() {
          window.location.reload();
        });
      });
    });

    var applyBtn = document.getElementById('CartDiscountApply');
    var discountInput = document.getElementById('CartDiscountCode');
    var discountError = document.getElementById('CartDiscountError');
    var discountWrap = document.querySelector('[data-applied-codes]');

    if (discountWrap && discountError) {
      var attempted = sessionStorage.getItem('discount_attempt');
      if (attempted) {
        sessionStorage.removeItem('discount_attempt');
        var applied = discountWrap.getAttribute('data-applied-codes').split('|').filter(Boolean);
        var found = applied.some(function (c) { return c === attempted.toUpperCase(); });
        if (!found) {
          discountError.hidden = false;
          if (discountInput) discountInput.value = attempted;
        }
      }
    }

    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', function () {
        var code = discountInput.value.trim();
        if (!code) return;
        sessionStorage.setItem('discount_attempt', code);
        if (discountError) discountError.hidden = true;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
      discountInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyBtn.click(); }
      });
      discountInput.addEventListener('input', function () {
        if (discountError) discountError.hidden = true;
      });
    }

    var btn = document.querySelector('[data-upsell-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.contact-form[data-klaviyo-company-id]');
    if (!section) return;

    var companyId = section.dataset.klaviyoCompanyId;
    var listId = section.dataset.klaviyoListId;
    if (!companyId || !listId) return;

    var form = section.querySelector('form');
    var emailInput = section.querySelector('[data-contact-email]');
    var optin = section.querySelector('[data-newsletter-optin]');
    if (!form || !emailInput || !optin) return;

    form.addEventListener('submit', function () {
      if (!optin.checked) return;
      var email = emailInput.value.trim();
      if (!email) return;

      var nameInput = form.querySelector('[name="contact[name]"]');
      var name = nameInput ? nameInput.value.trim() : '';
      var parts = name.split(' ');
      var firstName = parts[0] || '';
      var lastName = parts.slice(1).join(' ') || '';

      var profile = { email: email };
      if (firstName) profile.first_name = firstName;
      if (lastName) profile.last_name = lastName;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: listId,
              email: email,
              profile: { data: { type: 'profile', attributes: profile } }
            }
          }
        })
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-founder-toggle]').forEach(function(btn) {
    var body = btn.closest('.founder-story__copy').querySelector('[data-founder-copy]');
    if (!body) return;
    btn.addEventListener('click', function() {
      var open = body.classList.toggle('is-open');
      btn.textContent = open ? 'See less' : 'See more';
      btn.setAttribute('aria-expanded', open);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levive-ecosystem-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ecosystem-tabs').forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll('.ecosystem-tabs__tab');
    const panels = wrapper.querySelectorAll('.ecosystem-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.tabTarget;

        tabs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const target = wrapper.querySelector('#' + targetId);

        if (target) {
          target.classList.add('is-active');
          target.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levive-event-feature"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick(el, target) {
      var diff = target - Date.now();
      if (diff < -86400000) { el.style.display = 'none'; return; }
      if (diff <= 0) {
        el.textContent = 'Starting now';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }

    document.querySelectorAll('[data-countdown]').forEach(function(el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      tick(el, target);
      setInterval(function() { tick(el, target); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levive-hero-home"] && !Shopify.designMode) return;
  try {
    
window.odometerOptions = { duration: 1000 };

const ageCounter = document.querySelector('.age_counter');

if (ageCounter) {
  let counter = 42;

  setInterval(function () {
    if (counter === 37) {
      counter = 42;
    } else {
      counter--;
      ageCounter.innerHTML = counter;
    }
  }, 1000);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levive-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.levive-hero-general__btn[class*="klaviyo-form-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var formClass = Array.from(btn.classList).find(function(c) { return c.startsWith('klaviyo-form-'); });
      if (!formClass) return;
      var formId = formClass.replace('klaviyo-form-', '');
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levive-split-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-split-hero-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-split-hero-atc');
      var form = document.createElement('form');
      form.setAttribute('action', '/cart/add');
      form.method = 'post';
      var input = document.createElement('input');
      input.name = 'id';
      input.value = variantId;
      form.appendChild(input);
      document.body.appendChild(form);
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      document.body.removeChild(form);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiance-holimel-power"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('.radiance-holimel-power__track');
    var dots = document.querySelectorAll('.radiance-holimel-power__dot');
    if (!track || !dots.length) return;

    track.addEventListener('scroll', function() {
      var index = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach(function(dot, i) {
        dot.classList.toggle('radiance-holimel-power__dot--active', i === index);
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiance-holimel-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.radiance-holimel-video__player').forEach(function(player) {
      var video = player.querySelector('.radiance-holimel-video__inline-video');
      var btn = player.querySelector('.radiance-holimel-video__play-btn');
      var lastPlayTime = 0;

      function startPlay() {
        lastPlayTime = Date.now();
        video.play();
        btn.classList.add('is-hidden');
      }

      // touchstart + preventDefault kills the ghost click before it reaches the video
      btn.addEventListener('touchstart', function(e) {
        e.preventDefault();
        startPlay();
      }, { passive: false });

      // fallback for desktop (mouse)
      btn.addEventListener('click', startPlay);

      video.addEventListener('click', function() {
        if (Date.now() - lastPlayTime < 500) return;
        if (video.paused) {
          startPlay();
        } else {
          video.pause();
          btn.classList.remove('is-hidden');
        }
      });

      video.addEventListener('ended', function() {
        btn.classList.remove('is-hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiance-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slider = document.getElementById('radiance-slider');
    var divisor = document.getElementById('radiance-divisor');
    var handle = document.getElementById('radiance-handle');
    var beforeImg = document.getElementById('radiance-before-img');
    if (!slider || !divisor) return;

    function update() {
      var val = slider.value;
      if (beforeImg) beforeImg.style.clipPath = 'inset(0 ' + (100 - val) + '% 0 0)';
      divisor.style.width = val + '%';
      if (handle) handle.style.left = val + '%';
    }

    slider.addEventListener('input', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiance-why-different"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('.radiance-diff__carousel-track');
    var dots = document.querySelectorAll('.radiance-diff__dot');
    if (!track || !dots.length) return;

    track.addEventListener('scroll', function() {
      var index = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach(function(dot, i) {
        dot.classList.toggle('radiance-diff__dot--active', i === index);
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlp-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rlp-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = btn.nextElementSibling;
      btn.setAttribute('aria-expanded', !expanded);
      if (expanded) {
        answer.hidden = true;
      } else {
        answer.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlp-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rlp-thumb]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var src = btn.getAttribute('data-rlp-thumb');
      var main = btn.closest('.rlp-hero__images').querySelector('.rlp-hero__main-image img');
      if (main) main.src = src;
      btn.closest('.rlp-hero__thumbs').querySelectorAll('.rlp-hero__thumb-btn').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  document.querySelectorAll('.rlp-hero[data-rlp-variant]').forEach(function(hero) {
    var variantId = parseInt(hero.getAttribute('data-rlp-variant'), 10);
    var selectedQty = 2;
    var cards = hero.querySelectorAll('[data-rlp-qty-card]');

    cards.forEach(function(card) {
      if (parseInt(card.getAttribute('data-rlp-qty-card'), 10) === selectedQty) {
        card.classList.add('rlp-hero__card--selected');
      }
      card.addEventListener('click', function() {
        selectedQty = parseInt(card.getAttribute('data-rlp-qty-card'), 10);
        cards.forEach(function(c) { c.classList.remove('rlp-hero__card--selected'); });
        card.classList.add('rlp-hero__card--selected');
      });
    });

    var addBtn = hero.querySelector('[data-rlp-add-to-cart]');
    if (!addBtn) return;

    addBtn.addEventListener('click', function() {
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: selectedQty })
      }).then(function(res) {
        return res.json();
      }).then(function() {
        addBtn.disabled = false;
        if (typeof window.leviveOpenCart === 'function') {
          window.leviveOpenCart();
        } else {
          window.location.href = '/cart';
        }
      }).catch(function() {
        addBtn.disabled = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-cell-aging"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.science-cell-aging__accordion').forEach(accordion => {
    const items = [...accordion.querySelectorAll('details')];

    function closeItem(detail) {
      if (!detail.classList.contains('science-cell-aging__item--open')) return;
      detail.classList.remove('science-cell-aging__item--open');
      const body = detail.querySelector('.science-cell-aging__body');
      if (!body) return;
      body.style.height = body.scrollHeight + 'px';
      body.classList.remove('science-cell-aging__body--open');
      requestAnimationFrame(() => { body.style.height = '0px'; });
    }

    function openItem(detail) {
      detail.classList.add('science-cell-aging__item--open');
      const body = detail.querySelector('.science-cell-aging__body');
      if (!body) return;
      body.classList.add('science-cell-aging__body--open');
      body.style.height = body.scrollHeight + 'px';
      body.addEventListener('transitionend', () => { body.style.height = 'auto'; }, { once: true });
    }

    items.forEach(detail => {
      const wasOpen = detail.open;
      detail.setAttribute('open', '');
      const body = detail.querySelector('.science-cell-aging__body');
      if (wasOpen) {
        detail.classList.add('science-cell-aging__item--open');
        if (body) { body.classList.add('science-cell-aging__body--open'); body.style.height = 'auto'; }
      } else {
        if (body) body.style.height = '0px';
      }
    });

    items.forEach(detail => {
      detail.querySelector('summary').addEventListener('click', e => {
        e.preventDefault();
        const isOpen = detail.classList.contains('science-cell-aging__item--open');
        items.forEach(other => closeItem(other));
        if (!isOpen) openItem(detail);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-display"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick(el, target) {
      var diff = target - Date.now();
      if (diff < -86400000) { el.style.display = 'none'; return; }
      if (diff <= 0) { el.textContent = 'Starting now'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    document.querySelectorAll('.video-display__countdown[data-countdown]').forEach(function(el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      tick(el, target);
      setInterval(function() { tick(el, target); }, 1000);
    });
  })();

  document.querySelectorAll('.video-display__cta[class*="klaviyo-form-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var formClass = Array.from(btn.classList).find(function(c) { return c.startsWith('klaviyo-form-'); });
      if (!formClass) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formClass.replace('klaviyo-form-', '')]);
    });
  });

  document.querySelectorAll('[data-video-wrap]').forEach(function(wrap) {
    var poster = wrap.querySelector('[data-video-poster]');
    var playBtn = wrap.querySelector('[data-video-play]');
    var videoContainer = wrap.querySelector('[data-video-container]');
    var toggleBtn = wrap.querySelector('[data-video-toggle]');
    var video = wrap.querySelector('video');
    var section = wrap.closest('.video-display');
    if (!video) return;

    function setPlaying(playing) {
      if (playing) {
        section.classList.add('is-playing');
      } else {
        section.classList.remove('is-playing');
      }
    }

    function play() {
      if (poster) poster.style.display = 'none';
      if (videoContainer) videoContainer.style.display = '';
      video.play();
    }

    video.addEventListener('play', function() { setPlaying(true); });
    video.addEventListener('pause', function() { setPlaying(false); });
    video.addEventListener('ended', function() { setPlaying(false); });

    if (playBtn) playBtn.addEventListener('click', function(e) { e.stopPropagation(); play(); });
    if (poster) poster.addEventListener('click', play);
    if (videoContainer) videoContainer.addEventListener('click', function() {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
